/** Display names by ISO-ish team code (matches OpenLigaDB → alpha-2 mapping). sv / en. */
const T = {
  AR: { sv: "Argentina", en: "Argentina" },
  AT: { sv: "Österrike", en: "Austria" },
  AU: { sv: "Australien", en: "Australia" },
  BE: { sv: "Belgien", en: "Belgium" },
  BA: { sv: "Bosnien och Hercegovina", en: "Bosnia and Herzegovina" },
  BR: { sv: "Brasilien", en: "Brazil" },
  CA: { sv: "Kanada", en: "Canada" },
  CH: { sv: "Schweiz", en: "Switzerland" },
  CI: { sv: "Elfenbenskusten", en: "Ivory Coast" },
  CD: { sv: "Kongo-Kinshasa", en: "DR Congo" },
  CO: { sv: "Colombia", en: "Colombia" },
  CV: { sv: "Kap Verde", en: "Cape Verde" },
  CW: { sv: "Curaçao", en: "Curaçao" },
  CZ: { sv: "Tjeckien", en: "Czechia" },
  DE: { sv: "Tyskland", en: "Germany" },
  DZ: { sv: "Algeriet", en: "Algeria" },
  EC: { sv: "Ecuador", en: "Ecuador" },
  EG: { sv: "Egypten", en: "Egypt" },
  EN: { sv: "England", en: "England" },
  ES: { sv: "Spanien", en: "Spain" },
  FR: { sv: "Frankrike", en: "France" },
  GH: { sv: "Ghana", en: "Ghana" },
  HR: { sv: "Kroatien", en: "Croatia" },
  HT: { sv: "Haiti", en: "Haiti" },
  IR: { sv: "Iran", en: "Iran" },
  IQ: { sv: "Irak", en: "Iraq" },
  JO: { sv: "Jordanien", en: "Jordan" },
  JP: { sv: "Japan", en: "Japan" },
  KR: { sv: "Sydkorea", en: "South Korea" },
  MA: { sv: "Marocko", en: "Morocco" },
  MX: { sv: "Mexiko", en: "Mexico" },
  NL: { sv: "Nederländerna", en: "Netherlands" },
  NO: { sv: "Norge", en: "Norway" },
  NZ: { sv: "Nya Zeeland", en: "New Zealand" },
  PA: { sv: "Panama", en: "Panama" },
  PY: { sv: "Paraguay", en: "Paraguay" },
  PT: { sv: "Portugal", en: "Portugal" },
  QA: { sv: "Qatar", en: "Qatar" },
  SN: { sv: "Senegal", en: "Senegal" },
  TN: { sv: "Tunisien", en: "Tunisia" },
  TR: { sv: "Turkiet", en: "Türkiye" },
  US: { sv: "USA", en: "United States" },
  UY: { sv: "Uruguay", en: "Uruguay" },
  UZ: { sv: "Uzbekistan", en: "Uzbekistan" },
  ZA: { sv: "Sydafrika", en: "South Africa" },
  SA: { sv: "Saudiarabien", en: "Saudi Arabia" },
  SCT: { sv: "Skottland", en: "Scotland" },
  SE: { sv: "Sverige", en: "Sweden" },
  IT: { sv: "Italien", en: "Italy" },
  PL: { sv: "Polen", en: "Poland" },
  UA: { sv: "Ukraina", en: "Ukraine" },
  RS: { sv: "Serbien", en: "Serbia" },
  HU: { sv: "Ungern", en: "Hungary" },
  CM: { sv: "Kamerun", en: "Cameroon" },
  NG: { sv: "Nigeria", en: "Nigeria" },
  CL: { sv: "Chile", en: "Chile" },
  PE: { sv: "Peru", en: "Peru" },
  DK: { sv: "Danmark", en: "Denmark" },
};

/**
 * @param {string} code
 * @param {string} [apiName] fallback from API (e.g. German)
 * @param {"sv"|"en"} lang
 */
export function teamDisplayName(code, apiName, lang) {
  if (!code) return apiName || "";
  const row = T[code];
  if (!row) return apiName || code;
  return lang === "en" ? row.en : row.sv;
}
